import React, { useEffect, useState, useRef, useContext } from 'react';
import { DropdownList } from 'react-widgets';
import moment from 'moment-timezone';
import axios from 'axios';

import 'react-widgets/styles.css';

import { Alert, Stack } from '@mui/material';
import { Grid, TextField, List } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import PrimaryButton from './lib/buttons/PrimaryButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import Backdrop from '@material-ui/core/Backdrop';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import SecondaryButton from './lib/buttons/SecondaryButton';
import NeutralButton from './lib/buttons/NeutralButton';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faMinusCircle } from '@fortawesome/free-solid-svg-icons';

import { Loading } from '../stories/Loading';
import { FeatureContext } from '../App';

// V2 Fields
let totalExtraBeds = 0;

interface CheckOutProps {}

interface CheckOutStateType {
  today: Date;
  checkedRooms: Array<any>;
  foodBills: any;
  paymentModes: Array<string>;
  discountOptions: Array<number>;
  checkoutRes?: any;
  companyInfo?: any;
  shouldGenerateFoodMiscBill: boolean;
  notes?: any;
}

interface FormDataType {
  selectedRoom?: any;
  roomRent: string;
  noOfDays: number;
  roomPaymentMode: string;
  foodPaymentMode: string;
  foodDiscount: number;
  roomDiscount: number;
  checkOutDateTime: Date;
  graceTimeEnabled: boolean;
}

const defaultFormData = {
  roomRent: '',
  noOfDays: 0,
  roomPaymentMode: '',
  foodPaymentMode: '',
  foodDiscount: 0,
  roomDiscount: 0,
  checkOutDateTime: new Date(),
  graceTimeEnabled: false,
};

const defaultCheckOutState = {
  today: new Date(),
  checkedRooms: [],
  foodBills: {},
  companyInfo: {},
  paymentModes: ['Cash', 'UPI', 'Credit', 'C.C', 'Online'],
  discountOptions: [0, 5, 10, 15],
  shouldGenerateFoodMiscBill: false,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: 'auto',
    textAlign: 'start',
    margin: '8px',
    display: 'flex',
    flexDirection: 'column',
  },
  loadingContainer: {
    textAlign: 'start',
    height: 'calc(100VH - 120px)',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    width: '100VW',
  },
  sezAlertStack: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      marginLeft: '40px',
      marginRight: '40px',
    },
  },
  componentTitle: {
    color: '#142966',
    textAlign: 'center',
    textTransform: 'uppercase',
    fontSize: '24px',
    marginBottom: '0px',
  },
  separatorLine: {
    height: '2px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.up('sm')]: {
      width: 'calc(100% - 80px)',
    },
    background: '#004878',
    border: 'none',
  },
  checkoutGrid: {
    alignSelf: 'center',
    marginTop: '12px',
    marginBottom: '12px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.up('sm')]: {
      width: 'calc(100% - 80px)',
    },
  },
  componentSubHeader: {
    color: '#142966',
    textAlign: 'center',
    fontSize: '18px',
    marginBottom: '12px',
    textDecoration: 'underline',
  },
  guestInfoContainer: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      marginLeft: '40px',
      marginRight: '40px',
    },
    border: '1px solid black',
    borderRadius: '4px',
    marginBottom: '12px',
  },
  guestInfoTable: {
    flex: 1,
  },
  guestInfoSeparator: {
    background: '#004878',
    width: '2px',
    border: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  guestInfoDataKey: {
    maxWidth: '120px',
    color: '#004878',
    fontSize: '18px',
    fontWeight: 400,
    padding: '8px',
    verticalAlign: 'top',
  },
  guestInfoDataValue: {
    color: '#004878',
    fontSize: '18px',
    fontWeight: 700,
    padding: '8px',
    verticalAlign: 'top',
  },
  datePicker: {
    height: '24px',
    '&>div>input::active': {
      border: 'none',
    },
    '&>div>input': {
      height: '24px',
    },
  },
  foodAndLaundryContainer: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      marginLeft: '40px',
      marginRight: '40px',
    },
    borderRadius: '4px',
    marginBottom: '12px',
    '&>table tr': {
      height: '36px',
    },
  },
  foodLaundrySeparator: {
    marginTop: '36px',
    background: '#004878',
    border: 'none',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: '2px',
      marginTop: '12px',
    },
    [theme.breakpoints.up('sm')]: {
      width: '2px',
      height: 'auto',
    },
  },
  rentDetailsContainer: {
    marginTop: '12px',
    marginBottom: '12px',
    [theme.breakpoints.up('sm')]: {
      width: 'calc(100% - 80px)',
      alignSelf: 'center',
    },
  },
  particularsTable: {
    marginTop: '12px',
    marginBottom: '12px',
    [theme.breakpoints.up('sm')]: {
      width: 'calc(100% - 80px)',
      alignSelf: 'center',
    },
  },
  button: {
    maxWidth: '320px',
    width: '300%',
    marginBottom: '24px',
    marginTop: '24px',
    [theme.breakpoints.up('sm')]: {
      alignSelf: 'center',
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const toINR = (number: any) => {
  var x = number;
  x = x.toString();
  var afterPoint = '';
  if (x.indexOf('.') > 0) afterPoint = x.substring(x.indexOf('.'), x.length);
  x = Math.floor(x);
  x = x.toString();
  var lastThree = x.substring(x.length - 3);
  var otherNumbers = x.substring(0, x.length - 3);
  if (otherNumbers !== '') lastThree = ',' + lastThree;
  return (
    '\u20B9' +
    ' ' +
    otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') +
    lastThree +
    afterPoint
  );
};

const CheckOut = (props: CheckOutProps) => {
  const classes = useStyles();
  const features = useContext(FeatureContext);

  const [loading, setLoading] = useState(false);
  const [checkOutState, setCheckOutState] = useState<CheckOutStateType>(
    defaultCheckOutState
  );
  const [formData, setFormData] = useState<FormDataType>(defaultFormData);
  const [openGstEditor, setOpenGstEditor] = useState(false);
  const [newGstNumber, setNewGstNumber] = useState<string>('');
  const [checkoutGstNumber, setCheckoutGstNumber] = useState<string>();
  const [isSEZInvoice, setSEZInvoice] = useState<boolean>(false);
  const [forceEInvoice, setForceEInvoice] = useState<boolean>(false);
  const [invoiceInfo, setInvoiceInfo] = useState<any>();
  const [gstMappings, setGstMappings] = useState<[any]>();

  const [version, setVersion] = useState(1);
  const [showConfirmPayMode, setShowConfirmPayMode] = useState(false);
  const [confirmRentPayMode, setConfirmRentPayMode] = useState<string>();
  const [confirmFoodPayMode, setConfirmFoodPayMode] = useState<string>();

  useEffect(() => {
    getAllCheckedRooms();
    getAllGstMappings();
  }, []);

  const fetchInvoiceInfo = (checkinInfoId: any) => {
    axios
      .get(`/api/invoice?fetchOnly=true&checkinId=${checkinInfoId}`)
      .then((res) => res.data)
      .then((res) => setInvoiceInfo(res))
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    const selectedRoom = formData.selectedRoom;
    const checkoutDateTime = formData.checkOutDateTime;
    const discountPercent = formData.roomDiscount || 0;
    const foodDiscountPercent = formData.foodDiscount || 0;
    const graceTimeEnabled = formData.graceTimeEnabled || false;

    checkoutRoom.current = formData.selectedRoom;

    if (selectedRoom && selectedRoom.taxpayer_type === 'SEZ') {
      setSEZInvoice(true);
    } else {
      setSEZInvoice(false);
    }

    if (selectedRoom && selectedRoom.irn_status === 'Pending') {
      setForceEInvoice(true);
      fetchInvoiceInfo(selectedRoom.checkin_info_id);
    } else {
      setForceEInvoice(false);
      setInvoiceInfo(undefined);
    }

    if (selectedRoom && checkoutDateTime) {
      setLoading(true);
      setCheckOutState((c) => ({ ...c, checkoutRes: null }));

      const checkinId = selectedRoom.checkin_info_id;
      const checkoutOptions = {
        checkinId: checkinId,
        discountPercent: discountPercent,
        checkoutDateTime: checkoutDateTime,
        foodDiscountPercent: foodDiscountPercent,
        graceTimeEnabled: graceTimeEnabled,
      };

      axios
        .post(`/api/checkoutInfo`, checkoutOptions)
        .then((res) => res.data)
        .then((res) => {
          let generateFoodMiscBill = false;
          if (
            (res.food && res.food.netFoodBillAmount > 0) ||
            (res.misc && res.misc.total > 0)
          ) {
            generateFoodMiscBill = true;
          }
          setVersion(res.ver);
          setCheckOutState((c) => ({
            ...c,
            notes: [
              { note: selectedRoom.notes, date: '', time: '' },
              ...res.additionalNotes,
            ],
            checkoutRes: res,
            shouldGenerateFoodMiscBill: generateFoodMiscBill,
          }));
          setFormData((f) => ({ ...f, noOfDays: res.tariff.totalDays }));
          setLoading(false);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }, [
    formData.selectedRoom,
    formData.checkOutDateTime,
    formData.roomDiscount,
    formData.foodDiscount,
    formData.graceTimeEnabled,
    checkoutGstNumber,
  ]);

  const getAllGstMappings = () => {
    axios.get('/api/fetchGstMappings').then(({ data }) => {
      setGstMappings(data);
    });
  };

  const getAllCheckedRooms = (prevCheckinId = null) => {
    setLoading(true);

    axios
      .get('/api/getAllCheckedRooms')
      .then((res) => res.data)
      .then((res) => {
        if (res.err) {
          alert(res.err);
        } else {
          const { checkedRooms, foodBills } = res;
          setCheckOutState((c) => ({ ...c, checkedRooms, foodBills }));
          if (prevCheckinId) {
            let prevSelectedRoom = checkedRooms.find(
              (f: any) => f.checkin_info_id === prevCheckinId
            );
            setFormData((f) => ({...f, selectedRoom: prevSelectedRoom}));
            // console.log('Prev Selected Room: ', prevSelectedRoom);
          }
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };

  const resetCheckout = (refetch = true, prevCheckinId = null) => {
    setFormData(defaultFormData);
    setShowConfirmPayMode(false);
    checkoutRoom.current = null;

    if (refetch) {
      setCheckOutState(defaultCheckOutState);
      getAllCheckedRooms(prevCheckinId);
    } else {
      setCheckOutState((c) => ({
        ...defaultCheckOutState,
        checkedRooms: c.checkedRooms,
        foodBills: c.foodBills,
      }));
    }
  };

  const downloadInvoice = async (
    billId: string,
    checkinInfoId: string,
    isEInvoice = false
  ) => {
    try {
      const invResult = await axios.get(
        `/api/invoice?id=${billId}&checkinId=${checkinInfoId}`,
        {
          responseType: 'blob',
        }
      );
      const blob = invResult.data;
      var file = new Blob([blob], { type: 'application/pdf' });
      var url = URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href = url;
      let fileName = isEInvoice ? `ENIV-${billId}.pdf` : `Bill-${billId}.pdf`;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
    } catch (error) {
      alert('Failed to download invoice. Please try again later!');
      console.log(error);
    }
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (formData.noOfDays > 0) {
      const selectedRoom = formData.selectedRoom;
      const roomPayMode = formData.roomPaymentMode;
      const roomDiscountPercent = formData.roomDiscount;
      const foodPayMode = formData.foodPaymentMode;
      const foodDiscountPercent = formData.foodDiscount;
      const checkoutDateTime = formData.checkOutDateTime;
      const generateFoodMiscBill = checkOutState.shouldGenerateFoodMiscBill;
      const graceTimeEnabled = formData.graceTimeEnabled || false;

      if (!selectedRoom) {
        window.alert('Select Room to be checked out.');
      } else if (!roomPayMode || (generateFoodMiscBill && !foodPayMode)) {
        window.alert('Select Payment Mode.');
      } else if (
        isSEZInvoice &&
        checkOutState?.checkoutRes?.food?.netFoodBillAmount > 0
      ) {
        window.alert('Food bill should be Zero for SEZ!');
      } else {
        const checkoutData = {
          checkinId: selectedRoom.checkin_info_id,
          roomPayMode,
          discountPercent: roomDiscountPercent,
          foodPayMode,
          foodDiscountPercent, // not used
          checkoutDateTime,
          graceTimeEnabled,
        };
        try {
          const result = await axios.post('/api/performCheckout', checkoutData);
          const checkoutRes = result.data;
          await downloadInvoice(
            checkoutRes.bill_id,
            checkoutRes.checkin_info_id
          );
          if (checkoutRes.irn_status !== 'Pending') {
            resetCheckout();
            // Does not show the confirm paymode screen for regular invoices
            // if (features.confirmPayModeFeatureEnabled) {
            //   setShowConfirmPayMode(true);
            // } else {
            //   resetCheckout();
            // }
          } else {
            setForceEInvoice(true);
            fetchInvoiceInfo(selectedRoom.checkin_info_id);
          }
        } catch (err) {
          console.log(err);
        }
      }
    } else {
      window.alert('No of days stayed should be atleast 1.');
    }
  };

  const calculateMinCheckoutTime = (
    checkinDateStr: string,
    checkinTimeStr: string,
    checkOutDate: Date
  ) => {
    let checkinDate = moment(checkinDateStr + ' ' + checkinTimeStr);
    let isSameDay = moment(checkOutDate).isSame(checkinDate, 'day');

    if (isSameDay) {
      //let nowAddOneHour = moment(new Date()).add({ hours: 1 }).toDate();
      // console.log("Todays is: " + isToday);
      return checkinDate.add({ hours: 0.5 }).toDate();
    }

    return moment().startOf('day').toDate();
  };

  const calculateMaxCheckoutTime = (checkOutDate: Date) => {
    let isToday = moment(checkOutDate).isSame(moment(), 'day');

    if (isToday) {
      let nowAddOneHour = moment(new Date()).add({ hours: 2.5 }).toDate();
      return nowAddOneHour;
    }

    return moment().endOf('day').toDate(); // set to 11:59 PM today
  };

  const getFoodAndMiscDetailsView = (checkoutRes?: any) => {
    if (checkoutRes) {
      const foodInfo = checkoutRes.food;
      const miscInfo = checkoutRes.misc;

      return (
        <div className={classes.foodAndLaundryContainer}>
          <table style={{ flex: 1 }}>
            <thead key="food-table-header">
              <tr key="food-table-header-row">
                <th
                  colSpan={2}
                  style={{
                    paddingBottom: '12px',
                    textDecoration: 'underline',
                  }}
                >
                  Food Bill Details
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {features.foodTypeFeatureEnabled || features.packageFeatureEnabled
                ? [
                    <tr key="table-food-bill-type">
                      <td>
                        <span>Food Bill Type:</span>
                      </td>
                      <td>
                        {foodInfo.foodBillType}
                        {foodInfo.foodPackageAllowance > 0
                          ? ` (${foodInfo.foodPackageAllowance} X ${
                              formData.noOfDays
                            } = ${toINR(
                              foodInfo.foodPackageAllowance * formData.noOfDays
                            )})`
                          : ''}
                      </td>
                    </tr>,
                  ]
                : []}
              <tr key="table-total-alcohol-amount">
                <td>
                  <span>Total Alcohol Amount:</span>
                </td>
                <td>{toINR(foodInfo.alcoholBillAmount || 0)}</td>
              </tr>
              <tr key="table-total-food-amount">
                <td>
                  <span>Total Food Amount:</span>
                </td>
                <td>{toINR(foodInfo.foodBillAmount)}</td>
              </tr>
              {foodInfo.foodPackageAllowance > 0
                ? [
                    <tr key="table-package-discount">
                      <td style={{ maxWidth: '100px' }}>
                        <span>Package Discount:</span>
                      </td>
                      <td>
                        {toINR(
                          foodInfo.packageAmountUsedForFood +
                            foodInfo.packageAmountUsedForAlcohol
                        )}
                      </td>
                    </tr>,
                  ]
                : []}
              <tr key="table-payable-amount">
                <td>
                  <span>Payable Amount:</span>
                </td>
                <td style={{ color: 'red', fontWeight: 'bolder' }}>
                  {toINR(
                    (foodInfo.netFoodBillAmount || 0) +
                      (foodInfo.netAlcoholBillAmount || 0)
                  )}
                </td>
              </tr>
            </tbody>
          </table>
          <hr className={classes.foodLaundrySeparator} />
          <table style={{ flex: 1 }}>
            <thead>
              <tr>
                <th
                  colSpan={2}
                  style={{
                    paddingBottom: '12px',
                    textDecoration: 'underline',
                  }}
                >
                  Laundry Bill Details
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <span>Laundry Amount:</span>
                </td>
                <td>{toINR(miscInfo.amount)}</td>
              </tr>
              <tr>
                <td>
                  <span>Cgst Amount:</span>
                </td>
                <td>{toINR(Math.round(miscInfo.cgst * 100) / 100)}</td>
              </tr>
              <tr>
                <td>
                  <span>Sgst Amount:</span>
                </td>
                <td>{toINR(Math.round(miscInfo.sgst * 100) / 100)}</td>
              </tr>
              <tr>
                <td>
                  <span>Payable Amount:</span>
                </td>
                <td style={{ color: 'red', fontWeight: 'bolder' }}>
                  {toINR(Math.round(miscInfo.total * 100) / 100)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }

    return null;
  };

  const getV4RentDetailsView = (checkoutRes?: any) => {
    let noOfDays = 0;
    totalExtraBeds = 0;

    let gstPercent = 0;
    let rent = 0;
    let cgstRent = 0;
    let sgstRent = 0;
    let igstRent = 0;
    let totalRoomRent = 0;

    let extraBedRate = 0;
    let cgstExtraBed = 0;
    let sgstExtraBed = 0;
    let igstExtraBed = 0;
    let totalExtraBedCharge = 0;

    let lateChargeApplied = false;
    let lateChargeAmount = 0;
    let lateChargeSgstAmount = 0;
    let lateChargeCgstAmount = 0;
    let lateChargeIgstAmount = 0;
    let totalLateChargeAmount = 0;

    let discountApplied = false;
    let discountOnTariff = 0;

    let totalCgstAmount = 0;
    let totalSgstAmount = 0;
    let totalIgstAmount = 0;

    let totalAdvanceAmount = 0;
    let subTotalAmount = 0;
    let grandTotal = 0;
    let payableAmount = 0;

    if (checkoutRes && version >= 2) {
      const tariff = checkoutRes.tariff || {};

      gstPercent = tariff.cgstPercent + tariff.sgstPercent;
      cgstRent = tariff.cgstRoomAmount;
      sgstRent = tariff.sgstRoomAmount;
      igstRent = tariff.igstRoomAmount;

      extraBedRate = (checkoutRes.room || {}).extraBedRate;
      cgstExtraBed = tariff.cgstExtraBedAmount;
      sgstExtraBed = tariff.sgstExtraBedAmount;
      totalExtraBedCharge = tariff.totalExtraBedRentAmount;

      if (checkoutRes.tariff.discountApplied) {
        discountApplied = true;
        discountOnTariff =
          tariff.originalTariff - (checkoutRes.food.foodPackageAllowance || 0);

        rent = tariff.discountedTariff;
        totalRoomRent = tariff.totalDiscountedRentAmount;
      } else {
        rent = tariff.originalTariff;
        totalRoomRent = tariff.totalOriginalRentAmount;
      }

      noOfDays = tariff.totalDays;
      totalExtraBeds = tariff.totalExtraBeds;
      lateChargeApplied = tariff.lateChargeApplied;
      lateChargeAmount = tariff.lateCheckoutAmount;
      lateChargeSgstAmount = tariff.sgstLateCheckoutAmount;
      lateChargeCgstAmount = tariff.cgstLateCheckoutAmount;
      totalLateChargeAmount = tariff.totalLateCheckoutAmount;

      subTotalAmount = tariff.subTotalAmount;
      totalCgstAmount = tariff.sumTotalCgstAmount;
      totalSgstAmount = tariff.sumTotalSgstAmount;
      totalIgstAmount = tariff.sumTotalIgstAmount;

      totalAdvanceAmount = tariff.sumTotalAdvanceAmount;
      grandTotal = tariff.grandTotal;
      payableAmount = tariff.payableAmount;
    }

    const createData = (
      category: string,
      tariff: any,
      gstPercent: any,
      dayCount: any,
      rentAmount: any,
      cGst: any,
      sGst: any,
      iGst: any,
      total: any,
      rowColor?: string
    ) => {
      return {
        category,
        tariff,
        gstPercent,
        dayCount,
        rentAmount,
        cGst,
        sGst,
        iGst,
        total,
        rowColor,
      };
    };

    const rows = [];
    if (discountApplied) {
      rows.push(
        createData(
          `Room (Disc. on ${discountOnTariff} ${
            features.packageFeatureEnabled ? '+ Package' : ''
          })`,
          rent,
          gstPercent,
          noOfDays,
          rent * noOfDays,
          sgstRent,
          cgstRent,
          igstRent,
          totalRoomRent
        )
      );
    } else {
      rows.push(
        createData(
          `Room ( ${formData?.selectedRoom?.room_type || ''} )`,
          toINR(rent),
          gstPercent,
          noOfDays,
          toINR(rent * noOfDays),
          toINR(sgstRent),
          toINR(cgstRent),
          toINR(igstRent),
          toINR(totalRoomRent)
        )
      );
    }
    rows.push(
      createData(
        'Extra Bed',
        toINR(extraBedRate),
        gstPercent,
        totalExtraBeds,
        toINR(extraBedRate * totalExtraBeds),
        toINR(sgstExtraBed),
        toINR(cgstExtraBed),
        toINR(igstExtraBed),
        toINR(totalExtraBedCharge)
      )
    );

    if (lateChargeApplied) {
      rows.push(
        createData(
          'Late Checkout Charges',
          toINR(lateChargeAmount),
          gstPercent,
          1,
          toINR(lateChargeAmount),
          toINR(lateChargeSgstAmount),
          toINR(lateChargeCgstAmount),
          toINR(lateChargeIgstAmount),
          toINR(totalLateChargeAmount),
          '#f1c40f'
        )
      );
    }

    rows.push(
      createData(
        'Sub Total',
        '-',
        '-',
        '-',
        toINR(subTotalAmount),
        toINR(totalSgstAmount),
        toINR(totalCgstAmount),
        toINR(totalIgstAmount),
        toINR(grandTotal)
      )
    );

    rows.push(
      createData(
        'Advance Paid',
        '-',
        '-',
        '-',
        '-',
        '-',
        '-',
        '-',
        toINR(totalAdvanceAmount)
      )
    );

    rows.push(
      createData('Total', '-', '-', '-', '-', '-', '-', '-', toINR(payableAmount))
    );

    const StyledTableCell = withStyles((theme) => ({
      head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
      },
      body: {
        fontSize: 14,
      },
    }))(TableCell);

    const StyledTableRow = withStyles((theme) => ({
      root: {
        '&:nth-of-type(odd)': {
          backgroundColor: theme.palette.action.hover,
        },
      },
    }))(TableRow);

    return (
      <TableContainer
        component={Paper}
        className={classes.rentDetailsContainer}
      >
        <Table aria-label="simple table">
          <TableHead>
            <TableRow key="Heading">
              <StyledTableCell>Rent Details</StyledTableCell>
              <StyledTableCell align="right">Tariff</StyledTableCell>
              <StyledTableCell align="right">GST</StyledTableCell>
              <StyledTableCell align="right">Days</StyledTableCell>
              <StyledTableCell align="right">Rent Amount</StyledTableCell>
              {isSEZInvoice ? (
                <>
                  <StyledTableCell align="right">
                    IGST ({gstPercent}%)
                  </StyledTableCell>
                </>
              ) : (
                <>
                  <StyledTableCell align="right">
                    SGST ({gstPercent / 2}%)
                  </StyledTableCell>
                  <StyledTableCell align="right">
                    CGST ({gstPercent / 2}%)
                  </StyledTableCell>
                </>
              )}
              <StyledTableCell align="right">Total</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => {
              if (index === rows.length - 1) {
                return (
                  <TableRow key={row.category}>
                    <StyledTableCell style={{ fontWeight: 'bolder' }}>
                      {row.category}
                    </StyledTableCell>
                    <StyledTableCell
                      align="right"
                      style={{ fontWeight: 'bolder' }}
                    >
                      {row.tariff}
                    </StyledTableCell>
                    <StyledTableCell
                      align="right"
                      style={{ fontWeight: 'bolder' }}
                    >
                      {row.gstPercent}
                    </StyledTableCell>
                    <StyledTableCell
                      align="right"
                      style={{ fontWeight: 'bolder' }}
                    >
                      {row.dayCount}
                    </StyledTableCell>
                    <StyledTableCell
                      align="right"
                      style={{ fontWeight: 'bolder' }}
                    >
                      {row.rentAmount}
                    </StyledTableCell>
                    {isSEZInvoice ? (
                      <>
                        <StyledTableCell
                          align="right"
                          style={{ fontWeight: 'bolder' }}
                        >
                          {row.sGst}
                        </StyledTableCell>
                      </>
                    ) : (
                      <>
                        <StyledTableCell
                          align="right"
                          style={{ fontWeight: 'bolder' }}
                        >
                          {row.sGst}
                        </StyledTableCell>
                        <StyledTableCell
                          align="right"
                          style={{ fontWeight: 'bolder' }}
                        >
                          {row.cGst}
                        </StyledTableCell>
                      </>
                    )}

                    <StyledTableCell
                      align="right"
                      style={{ fontWeight: 'bolder', color: 'red' }}
                    >
                      {row.total}
                    </StyledTableCell>
                  </TableRow>
                );
              } else {
                return (
                  <StyledTableRow
                    key={row.category}
                    style={
                      row.rowColor ? { backgroundColor: row.rowColor } : {}
                    }
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      style={{ fontWeight: 'bolder' }}
                    >
                      {row.category}
                    </TableCell>
                    <TableCell align="right" style={{ fontWeight: 'bolder' }}>
                      {row.tariff}
                    </TableCell>
                    <TableCell align="right" style={{ fontWeight: 'bolder' }}>
                      {row.gstPercent}
                    </TableCell>
                    <TableCell align="right" style={{ fontWeight: 'bolder' }}>
                      {row.dayCount}
                    </TableCell>
                    <TableCell align="right" style={{ fontWeight: 'bolder' }}>
                      {row.rentAmount}
                    </TableCell>
                    {isSEZInvoice ? (
                      <>
                        <TableCell
                          align="right"
                          style={{ fontWeight: 'bolder' }}
                        >
                          {row.iGst}
                        </TableCell>
                      </>
                    ) : (
                      <>
                        <TableCell
                          align="right"
                          style={{ fontWeight: 'bolder' }}
                        >
                          {row.sGst}
                        </TableCell>
                        <TableCell
                          align="right"
                          style={{ fontWeight: 'bolder' }}
                        >
                          {row.cGst}
                        </TableCell>
                      </>
                    )}
                    <TableCell align="right" style={{ fontWeight: 'bolder' }}>
                      {row.total}
                    </TableCell>
                  </StyledTableRow>
                );
              }
            })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  const updateGstNumber = () => {
    if (newGstNumber && newGstNumber.length === 15 && checkoutRoom.current) {
      setLoading(true);
      setOpenGstEditor(false);
      axios
        .post('/api/updateGstNumber', {
          gstNumber: newGstNumber,
          checkinInfoId: checkoutRoom.current.checkin_info_id,
        })
        .then((res) => res.data)
        .then((checkoutRes) => {
          if (checkoutRes.errno > 0) {
            // console.log(checkoutRes);
            setNewGstNumber('');
            alert('Failed to update GST. Please try again.');
          } else {
            let prevCheckinId = checkoutRoom.current.checkin_info_id;
            resetCheckout(true, prevCheckinId);
            console.log('Successfully updated GST Number!');
          }
        });
    } else {
      setNewGstNumber('');
      alert('Invalid GST Number');
    }
  };

  const removeGstNumber = () => {
    if (checkoutRoom.current) {
      setLoading(true);
      axios
        .post('/api/removeGstNumber', {
          checkinInfoId: checkoutRoom.current.checkin_info_id,
        })
        .then((res) => res.data)
        .then((checkoutRes) => {
          if (checkoutRes.errno > 0) {
            alert('Failed to remove GST Number. Please try again.');
          } else {
            setCheckoutGstNumber('');
            setNewGstNumber('');
            setSEZInvoice(false);

            let prevCheckinId = checkoutRoom.current.checkin_info_id;
            resetCheckout(true, prevCheckinId);
            console.log('Successfully updated GST Number!');
          }
        });
    }
  };

  const generateEInvoice = (billId: string, checkinInfoId: string) => {
    setLoading(true);
    let confirmPayModeOptions = {};
    if (features.confirmPayModeFeatureEnabled) {
      confirmPayModeOptions = {
        confirmRentPayMode,
        confirmFoodPayMode,
      };
    }
    axios
      .post('/api/generateEInvoice', {
        billId,
        checkinInfoId,
        ...confirmPayModeOptions,
      })
      .then((res) => res.data)
      .then((invoiceRes) => {
        if (invoiceRes.errno > 0) {
          alert(invoiceRes.msg);
        } else {
          console.log('E-Invoice Generated Successfully!');
          downloadInvoice(billId, checkinInfoId, true);
          resetCheckout();
        }
      })
      .catch((err) => {
        alert('Unknwon Error while generating E-Invoice!');
      })
      .finally(() => setLoading(false));
  };

  const confirmPayModeAndReset = () => {
    if (confirmFoodPayMode || confirmRentPayMode) {
      axios
        .post('/api/confirmInvoicePayMode', {
          previousFoodPayMode: formData.foodPaymentMode,
          previousRentPayMode: formData.roomPaymentMode,
          foodPayMode: confirmFoodPayMode,
          rentPayMode: confirmRentPayMode,
          checkinInfoId: formData?.selectedRoom?.checkin_info_id,
        })
        .then((res) => res.data)
        .then((res) => {
          if (res.errno > 0) {
            alert(res.msg);
          } else {
            alert('Payment Mode Updated!');
            resetCheckout();
          }
        })
        .catch((err) => {
          alert('Unknwon Error while modifying paymode!');
        })
        .finally(() => setLoading(false));
    } else {
      resetCheckout();
    }
  };

  const getSEZAlertView = () => {
    const hasFoodBills =
      checkOutState?.checkoutRes?.food?.netFoodBillAmount > 0;
    return (
      <Stack spacing={0.5} className={classes.sezAlertStack}>
        <Alert
          severity={hasFoodBills ? 'warning' : 'success'}
          sx={{
            backgroundColor: hasFoodBills ? '#e55039' : 'green',
            color: 'white',
            fontWeight: 600,
            fontSize: '18px',
            '& .MuiAlert-icon': {
              color: 'white',
            },
            '& .css-1ytlwq5-MuiAlert-icon': {
              fontSize: '30px',
            },
          }}
        >
          SEZ - SPECIAL ECONOMIC ZONE
        </Alert>
        <Alert
          icon={false}
          severity="warning"
          variant="outlined"
          sx={{
            color: '#4b4b4b',
            fontWeight: 600,
            fontSize: '14px',
          }}
        >
          Food bills must be deleted for E-Invoice towards SEZ.
        </Alert>
      </Stack>
    );
  };

  const getInnerView = () => {
    if (forceEInvoice && invoiceInfo) {
      return (
        <div className={classes.root}>
          <h2 className={classes.componentSubHeader}>Performa Invoice</h2>
          <div className={classes.guestInfoContainer}>
            <table className={classes.guestInfoTable}>
              <tbody>
                <tr>
                  <td className={classes.guestInfoDataKey}>Name:</td>
                  <td className={classes.guestInfoDataValue}>
                    {invoiceInfo._first_name + ' ' + invoiceInfo._last_name}
                  </td>
                </tr>
                <tr>
                  <td className={classes.guestInfoDataKey}>Phone No:</td>
                  <td className={classes.guestInfoDataValue}>
                    {invoiceInfo._contact}
                  </td>
                </tr>
                <tr>
                  <td className={classes.guestInfoDataKey}>GST No:</td>
                  <td className={classes.guestInfoDataValue}>
                    {invoiceInfo._gst_number}
                  </td>
                </tr>
                <tr>
                  <td className={classes.guestInfoDataKey}>Address: </td>
                  <td className={classes.guestInfoDataValue}>
                    {invoiceInfo._address}
                  </td>
                </tr>
              </tbody>
            </table>
            <hr className={classes.guestInfoSeparator} />
            <table className={classes.guestInfoTable}>
              <tbody>
                <tr>
                  <td className={classes.guestInfoDataKey}>Bill Id:</td>
                  <td
                    className={classes.guestInfoDataValue}
                    style={{ color: '#d91e18' }}
                  >
                    {invoiceInfo.bill_id}
                  </td>
                </tr>
                <tr hidden={!features.confirmPayModeFeatureEnabled}>
                  <td className={classes.guestInfoDataKey}>Room Pay Mode:</td>
                  <td className={classes.guestInfoDataValue}>
                    <DropdownList
                      style={{
                        maxWidth: '300px',
                        display: 'inline-block',
                      }}
                      data={checkOutState.paymentModes}
                      onChange={(r) => setConfirmRentPayMode(r)}
                      value={confirmRentPayMode || invoiceInfo?._payment_mode}
                      disabled={thirdPartyBooking}
                    />
                  </td>
                </tr>
                <tr hidden={!features.confirmPayModeFeatureEnabled}>
                  <td className={classes.guestInfoDataKey}>Food Pay Mode:</td>
                  <td className={classes.guestInfoDataValue}>
                    <DropdownList
                      style={{
                        maxWidth: '300px',
                        display: 'inline-block',
                      }}
                      data={checkOutState.paymentModes}
                      onChange={(r) => setConfirmFoodPayMode(r)}
                      value={confirmFoodPayMode || invoiceInfo?._food_pay_mode}
                      disabled={!checkOutState.shouldGenerateFoodMiscBill}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <Grid
            container
            direction="row"
            alignItems="center"
            spacing={2}
            className={classes.checkoutGrid}
          >
            <Grid item xs={3} md={3} lg={3} />
            <Grid
              item
              xs={6}
              md={6}
              lg={6}
              style={{
                display: 'flex',
                flexDirection: 'column',
                border: '2px solid grey',
                borderRadius: '4px',
              }}
            >
              <h4
                style={{ marginTop: '4px', marginBottom: '4px' }}
                className={classes.componentSubHeader}
              >
                Payable Amount
              </h4>
              <br />
              <div
                style={{
                  display: 'flex',
                  flex: 1,
                  alignItems: 'center',
                  justifyContent: 'space-evenly',
                }}
              >
                <h3 style={{ marginTop: '4px', marginBottom: '4px' }}>Total</h3>
                <h3 style={{ marginTop: '4px', marginBottom: '4px' }}>-</h3>
                <h3 style={{ marginTop: '4px', marginBottom: '4px' }}>
                  Advance
                </h3>
                <h3 style={{ marginTop: '4px', marginBottom: '4px' }}>=</h3>
                <h3 style={{ marginTop: '4px', marginBottom: '4px' }}>
                  Payable Amount
                </h3>
              </div>
              <div
                style={{
                  display: 'flex',
                  flex: 1,
                  alignItems: 'center',
                  justifyContent: 'space-evenly',
                }}
              >
                <h3 style={{ marginTop: '4px', marginBottom: '4px' }}>
                  {invoiceInfo._grand_total +
                    invoiceInfo?._net_food_bill_amount}
                </h3>
                <h3 style={{ marginTop: '4px', marginBottom: '4px' }}>-</h3>
                <h3 style={{ marginTop: '4px', marginBottom: '4px' }}>
                  {invoiceInfo._total_advance_amount}
                </h3>
                <h3 style={{ marginTop: '4px', marginBottom: '4px' }}>=</h3>
                <h3 style={{ color: '#d91e18' }}>{invoiceInfo.balance}</h3>
              </div>
            </Grid>
            <Grid item xs={3} md={3} lg={3} />
          </Grid>
          <SecondaryButton
            onClick={(_: any) =>
              generateEInvoice(invoiceInfo.bill_id, invoiceInfo.checkin_info_id)
            }
            className={classes.button}
            color="secondary"
            style={{ marginTop: '8px', alignSelf: 'center' }}
          >
            CONFIRM
          </SecondaryButton>
        </div>
      );
    } else if (showConfirmPayMode) {
      return (
        <div className={classes.root}>
          <h2 className={classes.componentSubHeader}>Confirm Invoice</h2>
          <div className={classes.guestInfoContainer}>
            <table className={classes.guestInfoTable}>
              <tbody>
                <tr>
                  <td className={classes.guestInfoDataKey}>Name:</td>
                  <td className={classes.guestInfoDataValue}>
                    {firstName + ' ' + lastName}
                  </td>
                </tr>
                <tr>
                  <td className={classes.guestInfoDataKey}>Phone No:</td>
                  <td className={classes.guestInfoDataValue}>{phoneNo}</td>
                </tr>
              </tbody>
            </table>
            <hr className={classes.guestInfoSeparator} />
          </div>
          <Grid
            container
            direction="row"
            alignItems="center"
            spacing={2}
            className={classes.checkoutGrid}
          >
            <Grid item xs={6}>
              <label style={{ margin: '8px' }}> Room Pay Mode </label>
              <DropdownList
                style={{
                  maxWidth: '300px',
                  display: 'inline-block',
                }}
                data={checkOutState.paymentModes}
                onChange={(r) => setConfirmRentPayMode(r)}
                value={confirmRentPayMode || formData.roomPaymentMode}
                disabled={thirdPartyBooking}
              />
            </Grid>
            <Grid item xs={6}>
              <label style={{ margin: '8px' }}> Food Pay Mode </label>
              <DropdownList
                style={{
                  maxWidth: '300px',
                  display: 'inline-block',
                }}
                data={checkOutState.paymentModes}
                onChange={(r) => setConfirmFoodPayMode(r)}
                value={confirmFoodPayMode || formData.foodPaymentMode}
                disabled={!checkOutState.shouldGenerateFoodMiscBill}
              />
            </Grid>
          </Grid>
          <SecondaryButton
            onClick={confirmPayModeAndReset}
            className={classes.button}
            color="secondary"
            style={{ marginTop: '8px', alignSelf: 'center' }}
          >
            CONFIRM
          </SecondaryButton>
        </div>
      );
    } else {
      return (
        <div className={classes.root}>
          <h2 className={classes.componentSubHeader}>Customer Details</h2>
          <div className={classes.guestInfoContainer}>
            <table className={classes.guestInfoTable}>
              <tbody>
                <tr>
                  <td className={classes.guestInfoDataKey}>Name:</td>
                  <td className={classes.guestInfoDataValue}>
                    {firstName + ' ' + lastName}
                  </td>
                </tr>
                <tr>
                  <td className={classes.guestInfoDataKey}>Phone No:</td>
                  <td className={classes.guestInfoDataValue}>{phoneNo}</td>
                </tr>
                <tr>
                  <td className={classes.guestInfoDataKey}>
                    GST No:{' '}
                    <FontAwesomeIcon
                      icon={faEdit}
                      style={{
                        color: '#d91e18',
                        marginLeft: '8px',
                        marginTop: '3px',
                      }}
                      onClick={(_) =>
                        setOpenGstEditor(checkoutRoom.current !== undefined)
                      }
                    />
                  </td>
                  <td className={classes.guestInfoDataValue}>
                    {gstNumber}
                    {gstNumber ? (
                      <FontAwesomeIcon
                        icon={faMinusCircle}
                        style={{
                          color: '#d91e18',
                          marginLeft: '8px',
                          marginTop: '3px',
                        }}
                        onClick={removeGstNumber}
                      />
                    ) : (
                      ''
                    )}
                  </td>
                </tr>
                <tr>
                  <td className={classes.guestInfoDataKey}>Company:</td>
                  <td className={classes.guestInfoDataValue}>
                    {' '}
                    {`${
                      checkOutState.checkoutRes?.companyInfo?.legal_name || ''
                    } - ${checkOutState.checkoutRes?.companyInfo?.state || ''}`}
                  </td>
                </tr>
              </tbody>
            </table>
            <hr className={classes.guestInfoSeparator} />
            <table className={classes.guestInfoTable}>
              <tbody>
                <tr>
                  <td className={classes.guestInfoDataKey}>Register No:</td>
                  <td className={classes.guestInfoDataValue}>{checkinNo}</td>
                </tr>
                <tr>
                  <td className={classes.guestInfoDataKey}>Booking ID:</td>
                  <td className={classes.guestInfoDataValue}>{bookingId}</td>
                </tr>
                <tr>
                  <td className={classes.guestInfoDataKey}>Address: </td>
                  <td className={classes.guestInfoDataValue} rowSpan={2}>
                    {address}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <Backdrop
            className={classes.backdrop}
            open={openGstEditor}
            style={{
              alignItems: 'center',
              justifyItems: 'center',
            }}
          >
            <Dialog
              open={openGstEditor}
              onClose={() => setOpenGstEditor(false)}
              aria-labelledby="form-dialog-title"
            >
              <DialogTitle id="form-dialog-title">GST Editor</DialogTitle>
              <DialogContent>
                <div>
                  <DropdownList
                    style={{ flex: 1, width: 400, maxWidth: 400 }}
                    data={gstMappings}
                    groupBy={(info: any) => info.state}
                    textField={(info: any) => info.legal_name}
                    onChange={(r) => {
                      if (r) {
                        setNewGstNumber(r?.gstin);
                      } else {
                        setNewGstNumber('');
                      }
                    }}
                    renderListGroup={({ group }) => {
                      return (
                        <span
                          style={{
                            color: '#ff1757',
                            fontWeight: 600,
                            textDecoration: 'underline',
                          }}
                        >
                          {group}
                        </span>
                      );
                    }}
                    renderValue={({ item }) => {
                      return (
                        <span
                          style={{
                            color: 'black',
                            fontWeight: 400,
                          }}
                        >
                          {item?.legal_name}
                        </span>
                      );
                    }}
                    renderListItem={({ item }) => {
                      return (
                        <span
                          style={{
                            color: 'black',
                            fontWeight: 400,
                            fontSize: '14px',
                          }}
                        >
                          {item?.legal_name}
                        </span>
                      );
                    }}
                  />
                  <input
                    style={{
                      flex: 1,
                      width: 400,
                      maxWidth: 400,
                      marginTop: 40,
                      height: 24,
                    }}
                    name="new-gst-number"
                    disabled
                    type="text"
                    id="new-gst-number"
                    value={newGstNumber}
                    placeholder="New GST No"
                    required
                  />
                </div>
              </DialogContent>
              <DialogActions>
                <NeutralButton
                  onClick={() => {
                    setOpenGstEditor(false);
                    setNewGstNumber('');
                  }}
                  className={classes.button}
                  style={{ marginTop: '8px' }}
                >
                  Cancel
                </NeutralButton>
                <SecondaryButton
                  onClick={(_: any) => updateGstNumber()}
                  color="secondary"
                  className={classes.button}
                  style={{ marginTop: '8px' }}
                >
                  Update
                </SecondaryButton>
              </DialogActions>
            </Dialog>
          </Backdrop>

          {isSEZInvoice ? getSEZAlertView() : []}

          <Grid
            container
            direction="row"
            alignItems="center"
            spacing={2}
            className={classes.checkoutGrid}
          >
            <Grid item xs={3} md={3} lg={3} />
            <Grid
              item
              xs={12}
              md={6}
              lg={6}
              style={{
                display: 'flex',
                flexDirection: 'column',
                border: '2px solid grey',
                borderRadius: '4px',
              }}
            >
              <h4
                style={{ marginTop: '4px', marginBottom: '4px' }}
                className={classes.componentSubHeader}
              >
                Notes
              </h4>
              <div>
                <List dense={true}>
                  {checkOutState?.notes?.map((v: any, ind: number) => {
                    if (ind === 0) {
                      return (
                        <div
                          style={{
                            marginTop: 12,
                            color: '#182C61',
                            fontWeight: 700,
                            fontSize: 18,
                            marginBottom: 18,
                          }}
                          key={ind}
                        >
                          {v.note}
                        </div>
                      );
                    } else {
                      return (
                        <div
                          key={ind}
                          style={{ display: 'flex', alignItems: 'center' }}
                        >
                          <p
                            style={{
                              flex: 0.6,
                              marginTop: 8,
                              fontWeight: 700,
                              fontSize: 18,
                              color: '#b71540',
                            }}
                          >
                            {v.note}
                          </p>
                          <p
                            style={{
                              flex: 0.4,
                              fontSize: 18,
                              fontWeight: 700,
                              color: '#182C61',
                            }}
                          >
                            ( {v.date} {v.time} )
                          </p>
                        </div>
                      );
                    }
                  })}
                </List>
              </div>
            </Grid>
            <Grid item xs={3} md={3} lg={3} />
          </Grid>
          <Grid
            container
            direction="row"
            alignItems="center"
            spacing={2}
            className={classes.checkoutGrid}
          >
            <Grid item xs={6}>
              <label style={{ margin: '8px' }}> Check-Out Date </label>
              <DatePicker
                className={classes.datePicker}
                showTimeSelect
                dateFormat="dd-MMM-yy, h:mm aa"
                selectsRange={false}
                // excludeOutOfBoundsTimes
                maxDate={maxCheckoutDate}
                minDate={minCheckoutDate}
                minTime={minCheckoutTime}
                maxTime={maxCheckoutTime}
                selected={formData.checkOutDateTime}
                onChange={(newDate) => {
                  if (newDate != null && !Array.isArray(newDate)) {
                    setCheckOutState((c) => ({
                      ...c,
                      checkoutRes: null,
                      shouldGenerateFoodMiscBill: false,
                    }));
                    setFormData((f) => ({ ...f, checkOutDateTime: newDate }));
                  }
                }}
              />
            </Grid>
            <Grid item xs={6} />
            <Grid item xs={6}>
              <label style={{ margin: '8px' }}> Room Pay Mode </label>
              <DropdownList
                style={{
                  maxWidth: '300px',
                  display: 'inline-block',
                }}
                data={checkOutState.paymentModes}
                onChange={(r) =>
                  setFormData((f) => ({ ...f, roomPaymentMode: r }))
                }
                value={formData.roomPaymentMode || ''}
                disabled={thirdPartyBooking}
              />
            </Grid>
            <Grid item xs={6}>
              <label style={{ margin: '8px' }}> Room Disc % </label>
              <DropdownList
                style={{
                  maxWidth: '300px',
                  display: 'inline-block',
                }}
                disabled={!checkoutRoom.current || thirdPartyBooking}
                data={checkOutState.discountOptions}
                onChange={(r) => {
                  setFormData((f) => ({ ...f, roomDiscount: r }));
                  setCheckOutState((c) => ({
                    ...c,
                    checkoutRes: null,
                    shouldGenerateFoodMiscBill: false,
                  }));
                }}
                value={formData.roomDiscount}
              />
            </Grid>
            <Grid item xs={6}>
              <label style={{ margin: '8px' }}> Food Pay Mode </label>
              <DropdownList
                style={{
                  maxWidth: '300px',
                  display: 'inline-block',
                }}
                data={checkOutState.paymentModes}
                onChange={(r) =>
                  setFormData((f) => ({ ...f, foodPaymentMode: r }))
                }
                value={formData.foodPaymentMode || ''}
                disabled={!checkOutState.shouldGenerateFoodMiscBill}
              />
            </Grid>
            <Grid item xs={6}>
              <label style={{ margin: '8px' }}> Food Disc % </label>
              <DropdownList
                style={{
                  maxWidth: '300px',
                  display: 'inline-block',
                }}
                disabled={true}
                data={checkOutState.discountOptions}
                onChange={(r) => {
                  setFormData((f) => ({ ...f, foodDiscount: r }));
                  setCheckOutState((c) => ({
                    ...c,
                    checkoutRes: null,
                    shouldGenerateFoodMiscBill: false,
                  }));
                }}
                value={formData.foodDiscount}
              />
            </Grid>
          </Grid>

          <hr className={classes.separatorLine} />
          {getFoodAndMiscDetailsView(checkOutState.checkoutRes)}

          <hr className={classes.separatorLine} />
          {getV4RentDetailsView(checkOutState.checkoutRes)}

          {isSEZInvoice ? getSEZAlertView() : []}

          <Grid
            container
            direction="row"
            spacing={2}
            style={{ marginTop: '12px', flex: 1 }}
          >
            <Grid item xs={3} md={3} lg={3} />
            <Grid
              item
              xs={12}
              md={6}
              lg={6}
              style={{
                display: 'flex',
                flexDirection: 'column',
                border: '2px solid grey',
                borderRadius: '4px',
              }}
            >
              <h4
                style={{ marginTop: '4px', marginBottom: '4px' }}
                className={classes.componentSubHeader}
              >
                Grand Total
              </h4>
              <div>
                <h3
                  style={{
                    marginTop: '4px',
                    marginBottom: '4px',
                    textAlign: 'center',
                  }}
                >
                  <span style={{ color: 'red' }}>Room + Food + Misc = </span>
                  {checkOutState?.checkoutRes?.grandTotalStr || 0}
                </h3>
              </div>
            </Grid>
            <Grid item xs={3} md={3} lg={3} />
          </Grid>
          <PrimaryButton onClick={handleSubmit} className={classes.button}>
            Generate
          </PrimaryButton>
        </div>
      );
    }
  };

  let checkoutRoom = useRef<any>();
  let checkin_date = '';
  let checkin_time = '';
  let checkinDateTimeStr = '';
  let checkinDateStr = '';
  let checkinTimeStr = '';

  let minCheckoutDate: Date | null | undefined;
  let maxCheckoutDate: Date | null | undefined;
  let minCheckoutTime: Date | undefined;
  let maxCheckoutTime: Date | undefined;

  let firstName = '';
  let lastName = '';
  let address = '';
  let phoneNo = '';
  let gstNumber: {} | null | null | undefined;
  let checkinNo = '';
  let bookingId = '';
  let thirdPartyBooking = false;

  if (checkoutRoom.current) {
    let cr = checkoutRoom.current;
    checkin_date = cr.checkin_date || '';
    checkin_time = cr.checkin_time || '';

    let checkin_date_m = moment(checkin_date).tz('Asia/Kolkata');
    let checkin_time_m = moment(checkin_time, 'HH:mm:ss');

    checkinDateStr = checkin_date_m.format('YYYY-MM-DD');
    checkinTimeStr = checkin_time_m.format('HH:mm:ss');
    checkinDateTimeStr =
      checkin_date_m.format('DD-MMM-YY') +
      ', ' +
      checkin_time_m.format('h:mm A');

    minCheckoutDate = checkin_date_m.toDate();
    maxCheckoutDate = checkOutState.today;
    minCheckoutTime = calculateMinCheckoutTime(
      checkinDateStr,
      checkinTimeStr,
      formData.checkOutDateTime
    );
    maxCheckoutTime = calculateMaxCheckoutTime(formData.checkOutDateTime);

    firstName = cr.first_name;
    lastName = cr.last_name;
    address = cr.address;
    phoneNo = cr.contact;
    gstNumber = checkoutGstNumber || cr.gst_number || '';
    checkinNo = cr.checkin_no;
    bookingId = cr.ref_booking_id || '';

    thirdPartyBooking = cr.reference !== 'direct' && cr.reference !== 'other';
  }

  if (loading) {
    return (
      <div className={classes.loadingContainer}>
        <Loading />
      </div>
    );
  } else {
    return (
      <div className={classes.root}>
        <h2 className={classes.componentTitle}>Check-Out</h2>
        <hr className={classes.separatorLine} />
        <Grid
          container
          direction="row"
          alignItems="center"
          spacing={2}
          className={classes.checkoutGrid}
        >
          <Grid item xs={6}>
            <Autocomplete
              options={checkOutState.checkedRooms.sort(
                (a, b) => a.room_name - b.room_name
              )}
              groupBy={(r: any) =>
                features.groupRoomsByBlockFeatureEnabled
                  ? r.block_name
                  : r.floor_str
              }
              getOptionLabel={(r: any) => r.room_name}
              style={{ maxWidth: 300 }}
              renderInput={(params: { [x: string]: any }) => (
                <TextField {...params} label="Room No" variant="outlined" />
              )}
              onChange={(_, r) => {
                if (r != null) {
                  let onlineBooking =
                    r.reference !== 'direct' && r.reference !== 'other';
                  setCheckOutState((c) => ({
                    ...c,
                    checkoutRes: null,
                    shouldGenerateFoodMiscBill: false,
                  }));
                  setFormData((f) => ({
                    ...f,
                    selectedRoom: r,
                    roomPaymentMode: onlineBooking ? r.reference : null,
                    roomDiscount: 0,
                  }));
                } else {
                  resetCheckout(false);
                }
              }}
              value={formData.selectedRoom || null}
            />
          </Grid>
          <Grid item xs={6}>
            <label style={{ margin: '8px' }}> Check-In Date</label>
            <input
              style={{ height: '24px' }}
              name="check-in-date"
              type="text"
              id="check-in-date"
              disabled
              value={checkinDateTimeStr}
            />
          </Grid>
        </Grid>
        <hr className={classes.separatorLine} />
        {getInnerView()}
      </div>
    );
  }
};

export default CheckOut;
